import React from 'react';

// Packages
import { Col, Divider, Flex, Modal, Row, Skeleton, Tag, Typography } from 'antd';
import { DoubleRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const StatusUpdate = (props) => {
	const { openModal, handleCancel, loadingHistory, statusHistory, statusDescriptions, statusColors, statusQty, changeStatus } = props;

	const { t } = useTranslation();

	return (
		<Modal
			title={t('statusUpdate.modalTitle')}
			centered
			open={openModal}
			onCancel={handleCancel}
			maskClosable={false}
			width={700}
			footer={null}
		>
			<Typography.Title level={5} style={{ textAlign: 'center', marginBottom: '1rem' }}>{t('statusUpdate.history')}</Typography.Title>
			<Skeleton loading={loadingHistory} active>
				{statusHistory.count === 0 && <p>{t('statusUpdate.noHistory')}</p>}
				{statusHistory.count > 0 && statusHistory.history.map((history, index) => (
					<Row key={index} style={{ marginBottom: '1rem' }} justify='space-between' align='middle'>
						<Col span={6} style={{ textAlign: 'center' }}>
							<Tag color={statusColors(history?.prev_status)}>{statusDescriptions(history.prev_status)}</Tag>
						</Col>
						<Col span={12}>
							<Flex justify='space-around' align='middle'>
								<DoubleRightOutlined />
								<Typography.Text>{new Date(history.date.$date).toLocaleString(localStorage.getItem('i18nextLng'), { hour12: true })}</Typography.Text>
								<DoubleRightOutlined />
							</Flex>
						</Col>
						<Col span={6} style={{ textAlign: 'center' }}>
							<Tag color={statusColors(history?.current_status)}>{statusDescriptions(history.current_status)}</Tag>
						</Col>
					</Row>
				))}
			</Skeleton>
			<Divider />
			<Typography.Title level={5} style={{ textAlign: 'center', marginBottom: '1rem' }}>{t('statusUpdate.options')}</Typography.Title>
			<Row justify='center'>
				{Array.from({ length: statusQty }, (_, i) => i + 1).map((status, index) => (
					<Tag
						key={index}
						style={{ cursor: 'pointer', margin: '0 1rem 1em' }}
						color={statusColors(status)}
						onClick={() => changeStatus(status)}
					>
						{statusDescriptions(status)}
					</Tag>
				))}
			</Row>
		</Modal>
	)
}

StatusUpdate.propTypes = {
	openModal: PropTypes.bool.isRequired,
	handleCancel: PropTypes.func.isRequired,
	loadingHistory: PropTypes.bool.isRequired,
	statusHistory: PropTypes.object.isRequired,
	statusDescriptions: PropTypes.func.isRequired,
	statusColors: PropTypes.func.isRequired,
	statusQty: PropTypes.number.isRequired,
	changeStatus: PropTypes.func.isRequired
}

export default StatusUpdate;
